import { Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

const EasyCareTerms = () => {
  const { t } = useTranslation('ShopAddons');
  return (
    <Surface>
      <Txt variant={'smallRegular'} type={'span'} color={'subtle'}>
        {t('groupedEasyCare.asurionTerms.groupTerms')}
      </Txt>
    </Surface>
  );
};

export default EasyCareTerms;
